import styled from 'styled-components';
import Colors from "constants/Colors";
import { Breakpoints } from "constants/Breakpoints";
import { Text } from 'components/Text';

export const ContainerTableCoverage = styled.div`
    width: 66%;
`

export const HeadCoverage = styled.div`
  color: #FFF;
  font-size: 20px;
  font-weight: 700;
  background-color: ${Colors.PURPLE};
  border: 1px solid ${Colors.PURPLE};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 16px;
`

export const BodyCoverage = styled.div`
  padding: 16px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 8px 4px rgba(0, 0, 0, 0.1);
`
export const RowCoverage = styled.div`
  display: flex;
  flex-flow: wrap;
`

export const ValueCoverage = styled.div`
  margin-right: 10px;
  margin-bottom: 15px;
`

export const TitleColumnCoverage = styled.span`
  display: block;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 40px;
  margin-right: 10px;
  width: ${((props) => props.width ? props.width : '100%')}
`


export const TableComponent = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TableRow = styled.tr`
  vertical-align: top;
`;


export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-bottom: 0px;
  padding-left: 0px;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  span {
    font-size: 13px !important;
  }
`

export const TableBody = styled.tbody`
    tr {
    }
`;

export const TableCollum = styled.td`
  vertical-align: center;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  padding-bottom: 10px;
  padding-top: 10px;
  padding-right: 10px;
  display: table-cell;
  width: 100%

  &:first-child {
    padding-left: 10px;
  }

  @media screen and (min-width: ${Breakpoints.sm}) {
    width: ${(props) => props.width ? props.width : '100%'}
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const TableCollumCoverageName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0px;
`

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  font-weight: 700;

  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const SmallTitle = styled.h3`
  line-height: 20px;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 0px;
  margin-left: 5px;
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin-left: auto;
  margin-right: 15px;
  align-items: center;

  cursor: pointer;
`

export const TextButton = styled.span`
  font-size: 14px;
  color: #666666;
  font-weight: bold;
`

export const AddButton = styled.div`
  color: white;
  font-size: 22px;
  text-align: center;
  width:25px;
  height:25px;
  border: 0px;
  border-radius: 25px;
  background-color: #53565a;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 15px;
`;